/**
 * Created by eriksundqvist on 04/07/16.
 */
import React, {PropTypes} from 'react';
import NumericInput from 'react-numeric-input';
import WorkDateRemoveDayButton from './work-date-remove-day-button';

export class WorkDateRow extends React.Component {

  static propTypes = {
    daysIndex: PropTypes.number.isRequired,
    day: PropTypes.object.isRequired,
    removeDays: PropTypes.func.isRequired,
    editWorkHours: PropTypes.func.isRequired,
    rowData: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      workHours: this.props.rowData.workHours
    };

    this.editWorkHours = this.editWorkHours.bind(this);
    this.getSelectHoursOptions = this.getSelectHoursOptions.bind(this);
    this.editWorkHoursSelect = this.editWorkHoursSelect.bind(this);
  }

  editWorkHours (workHours) {
    this.setState({
      workHours: workHours
    });
    this.props.editWorkHours(this.props.daysIndex, workHours);
  }

  editWorkHoursSelect () {
    this.editWorkHours(this.refs.workHoursSelect.value);
  }

  getSelectHoursOptions () {
    let options = [];
    for (let i = 0.5; i<=24; i=i+0.5) {
      options.push(<option value={i} key={i}>{i}</option>);
    }
    return options;
  }

  render () {
    return (
      <li>
        <WorkDateRemoveDayButton
          daysIndex={this.props.daysIndex}
          day={this.props.day}
          removeDays={this.props.removeDays}
        />
        <p>{this.props.rowData.displayDate}</p>
        <NumericInput
          min={0.01}
          step={0.25}
          max={24}
          precision={2}
          value={this.props.rowData.workHours}
          onChange={this.editWorkHours}
        />
        <div className='select-btn-wrapper'>
          <div className='styled-select'>
            <select value={this.props.rowData.workHours} onChange={this.editWorkHoursSelect} ref={'workHoursSelect'}>
              {this.getSelectHoursOptions()}
            </select>
          </div>
        </div>
      </li>
    );
  }
}

export default WorkDateRow;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/work-date/work-date-row.js
 **/